<header matDialogTitle>
  <div>{{ title }}</div>
  <button mat-icon-button color="primary" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</header>

<div [innerHTML]="message" matDialogContent></div>

<div matDialogActions>
  <button mat-raised-button color="primary" type="button" matDialogClose (click)="confirm()">
    {{ confirmText }}
  </button>
  @if (!hideCancelAction) {
    <button mat-button type="button" color="primary" matDialogClose>
      {{ cancelText }}
    </button>
  }
</div>
